var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 8.27332C23.3567 7.67043 24.6433 7.67043 25.6875 8.27332L36.776 14.6752C37.8202 15.2781 38.4635 16.3923 38.4635 17.5981V30.4019C38.4635 31.6077 37.8202 32.7219 36.776 33.3248L25.6875 39.7267C24.6433 40.3296 23.3567 40.3296 22.3125 39.7267L11.224 33.3248C10.1798 32.7219 9.53654 31.6077 9.53654 30.4019V17.5981C9.53654 16.3923 10.1798 15.2781 11.224 14.6752L22.3125 8.27332Z",
    stroke: "#283593",
    strokeWidth: 2.25
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1012_10674",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 32,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 7.94856C23.2853 7.27868 24.7147 7.27868 25.875 7.94856L36.9635 14.3505C38.1237 15.0204 38.8385 16.2583 38.8385 17.5981V30.4019C38.8385 31.7417 38.1237 32.9796 36.9635 33.6495L25.875 40.0514C24.7147 40.7213 23.2853 40.7213 22.125 40.0514L11.0365 33.6495C9.87629 32.9796 9.16154 31.7417 9.16154 30.4019V17.5981C9.16154 16.2583 9.87629 15.0204 11.0365 14.3505L22.125 7.94856Z",
    fill: "#283593",
    stroke: "#9A9BA5",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1012_10674)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 19.5003,
    r: 4.01786,
    stroke: "#283593",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 36.8574C13.125 31.6798 17.3223 27.4824 22.5 27.4824H25.5C30.6777 27.4824 34.875 31.6798 34.875 36.8574V37.5003C34.875 40.1927 32.6924 42.3753 30 42.3753H18C15.3076 42.3753 13.125 40.1927 13.125 37.5003V36.8574Z",
    stroke: "#283593",
    strokeWidth: 2.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSelected);
export default __webpack_public_path__ + "static/media/admin_selected.38d444e948361a99e4ccebf3d69affdd.svg";
export { ForwardRef as ReactComponent };